import AddIcon from '@mui/icons-material/Add';
import {
  APP_DRAGGABLE_DRAWER_HEIGHT_VAR,
  MIN_DRAWER_HEIGHT,
} from 'components/Drawer/draggable-drawer/DraggableDrawer.constants';
import SplitFab from 'components/SplitFab/SplitFab';
import { getObjectValue } from 'utilities';
import { DEFAULT_BOTTOM_MARGIN_FOR_ADD_BUTTONS, Z_INDEX_FOR_ADD_BUTTONS } from './constants';
import { StyledFab, StyledIcon, StyledLabel } from './styles';
import { ExtendedFabButtonProps } from './types';

const ExtendedFabButton = ({
  id,
  btnStyle,
  customIcon,
  label,
  notFixed = false,
  onClick,
  secondaryActions,
  disabled,
  // this is for interactions with the drawer and a fab button to prevent overlapping
  addBottomMarginForDrawer,
  ...rest
}: ExtendedFabButtonProps) => {
  const Icon = customIcon ?? AddIcon;

  if (secondaryActions) {
    return (
      <SplitFab
        label={label}
        mainAction={onClick ? () => onClick({} as any) : () => {}}
        options={secondaryActions}
        disabled={disabled || false}>
        <Icon style={{ marginRight: '0.5rem' }} />
      </SplitFab>
    );
  }

  return (
    <StyledFab
      aria-label={label}
      className={`${!notFixed ? 'fixed' : ''} ${disabled ? 'disabled' : ''}`.trim()}
      color="primary"
      disabled={disabled}
      id={id}
      onClick={onClick}
      size="medium"
      style={{
        ...getObjectValue(btnStyle),
        bottom: addBottomMarginForDrawer
          ? `calc(var(${APP_DRAGGABLE_DRAWER_HEIGHT_VAR}, ${MIN_DRAWER_HEIGHT}px) + ${DEFAULT_BOTTOM_MARGIN_FOR_ADD_BUTTONS}px)`
          : `${DEFAULT_BOTTOM_MARGIN_FOR_ADD_BUTTONS}px`,
        zIndex: addBottomMarginForDrawer ? Z_INDEX_FOR_ADD_BUTTONS : undefined,
        ...rest.style,
      }}
      variant="extended"
      {...rest}>
      <StyledIcon>
        <Icon fontSize="small" />
      </StyledIcon>
      <StyledLabel>{label}</StyledLabel>
    </StyledFab>
  );
};

export default ExtendedFabButton;
